// ServiceInventoryToolbar.js
import React, { useState } from 'react';
import AddInventoryModal from '../modals/AddInventoryModal';
import './Toolbar.css';

const ServiceInventoryToolbar = ({ services, setFilteredServices, user }) => {
	const [isAddModalOpen, setAddModalOpen] = useState(false);

	const handleAddInventoryClick = () => {
		setAddModalOpen(true);
	};

	const handleCloseAddModal = () => {
		setAddModalOpen(false);
	};

	return (
		<div className="inventorynavigator-container">
			<div style={{ flexDirection: "row", display: 'flex', justifyContent: "flex-start", gap: "2rem" }}>
				<button className="nav-button" onClick={handleAddInventoryClick}>
					Add Category
				</button>
			</div>

			<div className="rightSide">
				{/* <form onSubmit={handleSearchSubmit}>
					<Autosuggest
						suggestions={suggestions}
						onSuggestionsFetchRequested={onSuggestionsFetchRequested}
						onSuggestionsClearRequested={onSuggestionsClearRequested}
						getSuggestionValue={(suggestion) => suggestion.title}
						renderSuggestion={renderSuggestion}
						inputProps={{
							placeholder: 'Search',
							value: searchTerm,
							onChange: handleSearchChange,
						}}
					/>
					<button type="submit">
						<img src={SearchIcon} alt="Search" className="searchImage" />
					</button>
				</form> */}
			</div>
			{isAddModalOpen && <AddInventoryModal handleCloseModal={handleCloseAddModal} user={user} />}
		</div>
	);
};

export default ServiceInventoryToolbar;
